let navigateFunction: (to: string) => void;

export const setNavigateFunction = (navigate: (to: string) => void) => {
	navigateFunction = navigate;
};

export const navigateTo = (to: string) => {
	if (navigateFunction) {
		navigateFunction(to);
	}
};
